module.exports = __webpack_public_path__ + "img/background-app-shop-dark.e76e781e.jpg";